import React from "react";

import "@fontsource/jetbrains-mono";
import "@fontsource/rubik";

import { Rebase, RebaseAuth, useRebaseAuthController } from "@rebasepro/app";
import { RebaseCMS, RebaseShell } from "@rebasepro/cms";
import { ErrorBoundary } from "@rebasepro/ui";
import { RebaseStudio } from "@rebasepro/studio";
import { collections } from "virtual:rebase-collections";

import { rebaseClient } from "./rebaseClient";

// Configuration from environment
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export function App() {
    const authController = useRebaseAuthController({
        client: rebaseClient,
        googleClientId: GOOGLE_CLIENT_ID
    });

    return (
        <ErrorBoundary fullPage>
            <Rebase
                client={rebaseClient}
                authController={authController}
            >
                <RebaseAuth />
                <RebaseCMS collections={collections}/>
                <RebaseStudio/>
                <RebaseShell title="Loyalty Admin"/>
            </Rebase>
        </ErrorBoundary>
    );
}
